import outgoingPostMessageUtils from '@/utils/eventCommunicationUtils/outgoingPostMessageUtils';

const askForQuickActionsData = () => {
  outgoingPostMessageUtils.post('get-quick-actions-data');
};

export default {
  askForQuickActionsData,
};
